function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["id", "size", "heading", "subheading", "copy", "actions", "actionsDirection", "creativeArea", "offKilterDesign", "background", "confetti", "classes"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import classnames from "classnames";
import { useClasses } from "@xo-union/react-css-modules";
import { useUniqueID } from "@xo-union/react-unique-id";
import { useMainContentLabel } from "@xo-union/ui-accessibility";
import { Editorial } from "@xo-union/tk-ui-typography";
import { MastheadProvider } from "../../context/mastheadContext.js";
import ConfettiBackground from "../ConfettiBackground/index.js";
import styles from "./styles.css";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Masthead = function Masthead(_ref) {
  var idProp = _ref.id,
    size = _ref.size,
    heading = _ref.heading,
    subheading = _ref.subheading,
    copy = _ref.copy,
    actions = _ref.actions,
    _ref$actionsDirection = _ref.actionsDirection,
    actionsDirection = _ref$actionsDirection === void 0 ? 'left' : _ref$actionsDirection,
    creativeArea = _ref.creativeArea,
    offKilterDesign = _ref.offKilterDesign,
    background = _ref.background,
    confetti = _ref.confetti,
    classesProp = _ref.classes,
    passThroughProps = _objectWithoutProperties(_ref, _excluded);
  var uniqueId = useUniqueID();
  var layoutContext = useMainContentLabel();
  var layoutId = layoutContext && layoutContext.id;
  var id = idProp || layoutId || uniqueId;
  var classes = useClasses(styles, classesProp);

  // Defaults defined by design
  var defaultBackground = size === 'lg' ? 'fill-champagne' : 'fill-white';
  var defaultOffKilterDesign = size === 'lg';

  // If `offKilterDesign` then CreativeArea alignment needs to be `bottom`
  var creativeAreaAlignment = offKilterDesign !== false && defaultOffKilterDesign ? 'bottom' : 'center';

  // Throw errors for combinations not allowed by design
  if (offKilterDesign && size !== 'lg') {
    throw new Error("Off-kilter design can't be used with size: ".concat(size));
  }
  if (confetti && size !== 'lg') {
    throw new Error("Confetti can't be used with size: ".concat(size));
  }
  if (subheading && size !== 'sm') {
    throw new Error("Subheading can't be used with size: ".concat(size));
  }
  if (creativeArea && actionsDirection === 'right') {
    throw new Error("Can't have Actions aligned on the ".concat(actionsDirection, " while also having Creative Area"));
  }
  return /*#__PURE__*/_jsx(MastheadProvider, {
    size: size,
    id: id,
    creativeAreaAlignment: creativeAreaAlignment,
    children: /*#__PURE__*/_jsxs("div", _objectSpread(_objectSpread({
      className: classnames(classes.masthead, classes["size-".concat(size)], classes["background-".concat(background || defaultBackground)], actionsDirection === 'right' && classes['actions-direction-right'], offKilterDesign !== false && defaultOffKilterDesign && classes['off-kilter-design'], !creativeArea && classes['no-creative-area'], !creativeArea && !actions && classes['minimal-props'])
    }, passThroughProps), {}, {
      children: [size === 'lg' && confetti && /*#__PURE__*/_jsx(ConfettiBackground, {
        set: confetti
      }), /*#__PURE__*/_jsx("div", {
        className: classes.wrapper,
        children: /*#__PURE__*/_jsxs("div", {
          className: classes.content,
          children: [/*#__PURE__*/_jsxs("div", {
            className: classes['main-content'],
            children: [heading, size === 'sm' && subheading, copy && /*#__PURE__*/_jsx(Editorial, {
              as: "small",
              className: classes.copy,
              children: copy
            }), actions && actionsDirection === 'left' && /*#__PURE__*/_jsx("div", {
              className: classes.actions,
              children: actions
            })]
          }), (actions && actionsDirection === 'right' || creativeArea) && /*#__PURE__*/_jsx("div", {
            className: classes['secondary-content'],
            children: actions && actionsDirection === 'right' ? actions : creativeArea
          })]
        })
      })]
    }))
  });
};
export default Masthead;